'use strict';

var Sugar = require('sugar-core'),
    append = require('./append');

Sugar.Array.alias('insert', 'append');

module.exports = Sugar.Array.insert;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/array/insert.js
// module id = 385
// module chunks = 0